import React from "react";
import { motion } from "motion/react";
import { useNavigate } from "react-router-dom";
import { FiArrowUpRight, FiMail, FiHeart } from "react-icons/fi";
import { HiSparkles } from "react-icons/hi2";
import logo from "../../Image/Client/logo1.png";
import appstore from "../../Image/Client/appStore.svg";
import playstore from "../../Image/Client/playstore.svg";
import blueTick from "../../Image/Client/blueTick.svg";
import insta from "../../Image/Client/insta.svg";
import fb from "../../Image/Client/fb.svg";
import thr from "../../Image/Client/thr.svg";

const CATEGORIES = [
    { id: "6884ba26a780b569d63a33ae", name: "Man's Prompt" },
    { id: "68c8f148063a9cd5b4b419b5", name: "Men Trending Art" },
    { id: "68c805a17afa01e10760feca", name: "Women Red Saree Art" },
    { id: "6884ba2eea4abc0f5b8e903e", name: "Baby Girl" },
    { id: "6884ba21ea4abc0f5b8e9038", name: "Baby Boy" },
    { id: "68c13b331f4d0bff92b4f553", name: "3D Model" },
];

const LEARN_LINKS = [
    { label: "Game", path: "/quizzy/", external: true },
    { label: "About Us", path: "/about" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Terms & Conditions", path: "/terms" },
    { label: "FAQs", path: "/faqs" },
    { label: "Contact Us", path: "/contact" },
    { label: "Blogs", path: "/blog" },
];

const SOCIALS = [
    { icon: insta, alt: "Instagram", url: "https://www.instagram.com/picpromptify/" },
    { icon: fb, alt: "Facebook", url: "https://www.facebook.com/profile.php?id=61579052481615" },
    { icon: thr, alt: "Threads", url: "https://www.threads.com/@picpromptify" },
];

const ClientFooter = () => {
    const navigate = useNavigate();
    const year = new Date().getFullYear();

    return (
        <footer className='w-full mt-12 md:mt-20'>
            <div className='mx-auto w-full max-w-7xl px-3 sm:px-4'>
                {/* TOP CTA BAND */}
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    className='ios-glass-dark relative rounded-3xl p-6 md:p-10 overflow-hidden'
                >
                    {/* Decorative glow */}
                    <div
                        aria-hidden
                        className='absolute -top-20 -right-16 w-72 h-72 rounded-full opacity-40 blur-3xl pointer-events-none'
                        style={{
                            background:
                                "radial-gradient(circle, #7F00FF 0%, transparent 70%)",
                        }}
                    />
                    <div
                        aria-hidden
                        className='absolute -bottom-20 -left-16 w-72 h-72 rounded-full opacity-25 blur-3xl pointer-events-none'
                        style={{
                            background:
                                "radial-gradient(circle, #FCFA02 0%, transparent 70%)",
                        }}
                    />

                    <div className='relative flex flex-col md:flex-row md:items-center md:justify-between gap-6'>
                        <div className='flex-1 min-w-0'>
                            <div className='inline-flex items-center gap-2 ios-glass px-3 py-1 rounded-full text-[10px] md:text-xs text-client-font/85 mb-3'>
                                <HiSparkles style={{ color: "#FCFA02" }} />
                                <span className='tracking-wider uppercase'>
                                    Available on all platforms
                                </span>
                            </div>
                            <h3 className='text-2xl md:text-4xl font-bold text-client-font leading-tight'>
                                Get the{" "}
                                <span
                                    style={{
                                        background:
                                            "linear-gradient(90deg, #FCFA02, #FF8AFF, #7F00FF)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                        backgroundClip: "text",
                                    }}
                                >
                                    PicPromptify
                                </span>{" "}
                                app
                            </h3>
                            <p className='text-client-font/55 text-sm md:text-base mt-2 max-w-md'>
                                Generate stunning AI image prompts on the go — anytime, anywhere.
                            </p>
                            <div className='flex items-center gap-2 mt-4'>
                                <img
                                    src={blueTick}
                                    alt='verified'
                                    className='w-4 md:w-5'
                                />
                                <span className='text-client-font font-semibold text-sm md:text-base'>
                                    100K+
                                </span>
                                <span className='text-client-font/55 text-xs md:text-sm'>
                                    downloads
                                </span>
                            </div>
                        </div>

                        <div className='flex flex-col sm:flex-row items-stretch sm:items-center gap-3 shrink-0'>
                            <motion.img
                                src={appstore}
                                alt='App Store'
                                whileHover={{ y: -3, scale: 1.04 }}
                                whileTap={{ scale: 0.97 }}
                                className='w-32 md:w-36 h-auto cursor-pointer drop-shadow-lg'
                                onClick={() =>
                                    window.open(
                                        "https://apps.apple.com/in/app/picpromptify/id6749353177",
                                        "_blank"
                                    )
                                }
                            />
                            <motion.img
                                src={playstore}
                                alt='Play Store'
                                whileHover={{ y: -3, scale: 1.04 }}
                                whileTap={{ scale: 0.97 }}
                                className='w-32 md:w-36 h-auto cursor-pointer drop-shadow-lg'
                                onClick={() =>
                                    window.open(
                                        "https://play.google.com/store/apps/details?id=com.picprompter.pixprompt.prompt.ly.android",
                                        "_blank"
                                    )
                                }
                            />
                        </div>
                    </div>
                </motion.div>

            </div>

            {/* MAIN GRID — full width, distinct panel with animated bg */}
            <div
                className='relative w-full mt-10 md:mt-14 overflow-hidden'
                style={{
                    background: "rgba(255,255,255,0.025)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                    borderTop: "1px solid rgba(255,255,255,0.08)",
                }}
            >
                {/* Background orbs — static (animating blurred layers is a heavy per-frame repaint) */}
                <div
                    aria-hidden
                    className='absolute top-10 left-[10%] w-72 h-72 rounded-full opacity-25 blur-3xl pointer-events-none'
                    style={{
                        background:
                            "radial-gradient(circle, #7F00FF 0%, transparent 70%)",
                    }}
                />
                <div
                    aria-hidden
                    className='absolute bottom-10 right-[15%] w-80 h-80 rounded-full opacity-20 blur-3xl pointer-events-none'
                    style={{
                        background:
                            "radial-gradient(circle, #FCFA02 0%, transparent 70%)",
                    }}
                />
                <div
                    aria-hidden
                    className='absolute top-1/3 right-[35%] w-64 h-64 rounded-full opacity-15 blur-3xl pointer-events-none'
                    style={{
                        background:
                            "radial-gradient(circle, #FF8AFF 0%, transparent 70%)",
                    }}
                />
                {/* Subtle grid pattern overlay */}
                <div
                    aria-hidden
                    className='absolute inset-0 pointer-events-none opacity-[0.04]'
                    style={{
                        backgroundImage:
                            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
                        backgroundSize: "48px 48px",
                    }}
                />

                <div className='relative w-full px-4 sm:px-6 md:px-10 lg:px-14 py-10 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10'>
                    {/* Brand column */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className='md:col-span-5'
                    >
                        <motion.img
                            src={logo}
                            alt='PicPromptify'
                            whileHover={{ scale: 1.04 }}
                            onClick={() => navigate("/")}
                            className='w-32 md:w-40 h-auto cursor-pointer'
                        />
                        <p className='text-client-font/70 text-sm md:text-base leading-relaxed mt-4 max-w-sm'>
                            AI image prompts made simple — the ultimate platform for
                            creators, artists, and AI enthusiasts.
                        </p>

                        {/* Socials */}
                        <div className='mt-6 flex items-center gap-3'>
                            <span className='text-client-font/45 text-xs uppercase tracking-[0.2em]'>
                                Follow
                            </span>
                            <div className='flex items-center gap-2'>
                                {SOCIALS.map((s) => (
                                    <motion.button
                                        key={s.alt}
                                        onClick={() => window.open(s.url, "_blank")}
                                        whileHover={{
                                            scale: 1.12,
                                            y: -3,
                                        }}
                                        whileTap={{ scale: 0.92 }}
                                        aria-label={s.alt}
                                        className='ios-glass-btn w-9 h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center'
                                    >
                                        <img src={s.icon} alt={s.alt} className='w-4 md:w-5' />
                                    </motion.button>
                                ))}
                            </div>
                        </div>

                        {/* Contact */}
                        <motion.a
                            href='mailto:picpromptify@gmail.com'
                            whileHover={{ x: 4 }}
                            className='inline-flex items-center gap-2 mt-6 text-client-font/65 text-sm hover:text-client-title transition-colors'
                        >
                            <FiMail className='text-base' />
                            picpromptify@gmail.com
                            <FiArrowUpRight />
                        </motion.a>
                    </motion.div>

                    {/* Category column */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        className='md:col-span-4'
                    >
                        <div className='flex items-center gap-2 mb-4'>
                            <div
                                className='w-1 h-4 rounded-full'
                                style={{
                                    background: "linear-gradient(180deg, #7F00FF, #FCFA02)",
                                }}
                            />
                            <h4 className='text-client-font font-semibold text-sm tracking-wide uppercase'>
                                Categories
                            </h4>
                        </div>
                        <ul className='space-y-2.5'>
                            {CATEGORIES.map((cat) => (
                                <li key={cat.id}>
                                    <motion.button
                                        onClick={() => navigate(`/category/${cat.id}`)}
                                        whileHover={{ x: 6 }}
                                        className='group text-client-font/65 hover:text-client-font text-sm md:text-base inline-flex items-center gap-1.5 transition-colors'
                                    >
                                        <span className='w-1 h-1 rounded-full bg-client-font/30 group-hover:bg-client-primary transition-colors' />
                                        {cat.name}
                                    </motion.button>
                                </li>
                            ))}
                        </ul>
                    </motion.div>

                    {/* Learn column */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        className='md:col-span-3'
                    >
                        <div className='flex items-center gap-2 mb-4'>
                            <div
                                className='w-1 h-4 rounded-full'
                                style={{
                                    background: "linear-gradient(180deg, #FCFA02, #7F00FF)",
                                }}
                            />
                            <h4 className='text-client-font font-semibold text-sm tracking-wide uppercase'>
                                Learn
                            </h4>
                        </div>
                        <ul className='space-y-2.5'>
                            {LEARN_LINKS.map((link) => (
                                <li key={link.path}>
                                    <motion.button
                                        onClick={() => (link.external ? (window.location.href = link.path) : navigate(link.path))}
                                        whileHover={{ x: 6 }}
                                        className='group text-client-font/65 hover:text-client-font text-sm md:text-base inline-flex items-center gap-1.5 transition-colors'
                                    >
                                        <span className='w-1 h-1 rounded-full bg-client-font/30 group-hover:bg-client-primary transition-colors' />
                                        {link.label}
                                    </motion.button>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                </div>

            </div>

            {/* BOTTOM BAR — full width, connected to main grid */}
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className='w-full border-t border-white/10'
                style={{
                    background: "rgba(255,255,255,0.02)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                }}
            >
                <div className='w-full flex flex-col sm:flex-row items-center justify-between gap-3 px-4 sm:px-6 md:px-10 lg:px-14 py-6'>
                    <p className='text-client-font/45 text-[11px] md:text-xs tracking-wide'>
                        © {year} PicPromptify. All rights reserved.
                    </p>
                    <p className='text-client-font/45 text-[11px] md:text-xs inline-flex items-center gap-1.5'>
                        Made with
                        <motion.span
                            animate={{ scale: [1, 1.2, 1] }}
                            transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
                            style={{ color: "#FF6B9D", display: "inline-flex" }}
                        >
                            <FiHeart className='fill-current' />
                        </motion.span>
                        in India
                        <span className='ml-0.5' aria-label='India flag'>
                            🇮🇳
                        </span>
                    </p>
                </div>
            </motion.div>
        </footer>
    );
};

export default ClientFooter;
